export default __webpack_public_path__ + "static/media/LAND ROVER.f8cd7ee6.png";